import { useTranslation } from "react-i18next";
import { useInView } from "@/hooks/useInView";

const products = [
  { name: "Spinosad", level: 72, delta: "-2 L", color: "hsl(177 58% 52%)" },
  { name: "Abamectin", level: 40, delta: "-1 L", color: "hsl(213 70% 51%)" },
  { name: "Copper", level: 88, delta: null, color: "hsl(123 43% 44%)" },
  { name: "Sulfur", level: 55, delta: "-3 L", color: "hsl(45 100% 51%)" },
];

export function InventoryAutomationIllustration() {
  const { t } = useTranslation();
  const { ref, inView } = useInView();

  return (
    <div ref={ref} className="rounded-2xl border border-landing-border bg-white p-6 shadow-soft">
      <p className="mb-4 text-sm font-semibold text-foreground">
        {t("landing.illustrations.liveInventory", "Live Inventory")}
      </p>

      <div className="space-y-3">
        {products.map((p, i) => (
          <div
            key={i}
            className="transition-all duration-350"
            style={{
              opacity: inView ? 1 : 0,
              transform: inView ? "translateX(0)" : "translateX(10px)",
              transitionDelay: `${i * 0.1}s`,
            }}
          >
            <div className="mb-1 flex items-center justify-between text-xs">
              <span className="text-muted-foreground">{p.name}</span>
              {p.delta && (
                <span className="rounded-full bg-destructive/10 px-1.5 py-0.5 text-[10px] font-semibold text-destructive">
                  {p.delta}
                </span>
              )}
            </div>
            <div className="h-2.5 w-full overflow-hidden rounded-full bg-muted">
              <div
                className="h-full rounded-full transition-all duration-800"
                style={{
                  backgroundColor: p.color,
                  width: inView ? `${p.level}%` : `${p.level + 8}%`,
                  transitionDelay: `${i * 0.1 + 0.3}s`,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
